import styled from 'styled-components';

export const ServiceCenterContentsWrapper = styled.div`
  margin: 5px 20px 20px;
  padding-bottom: 30px;
`;
